import React, { useState } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Banner, Button, Stack } from "@shopify/polaris";

import TabContainer from "../../components/components/TabContainer";

import LocationNew from "./pages/locations/New";
import LocationEdit from "./pages/locations/Edit";

import CitiesEdit from "./pages/cities/Edit";
import RegionsEdit from "./pages/regions/Edit";
import CountriesEdit from "./pages/countries/Edit";

import LocationMap from "./pages/map/Index";

import LocationsIndex from "./pages/locations/Index";

import LocationsImportNew from "./pages/locations/import/New";
import LocationsImportShow from "./pages/locations/import/Show";

import CitiesIndex from "./pages/cities/Index";
import RegionsIndex from "./pages/regions/Index";
import CountriesIndex from "./pages/countries/Index";

import {
  LocationsMinor,
  CirclePlusOutlineMinor,
  GlobeMinor,
} from "@shopify/polaris-icons";

export default function PlacesIndex(props) {
  const { t, i18n } = useTranslation();
  const [showDebug, setShowDebug] = useState(true);

  const switchLocale = (locale) => {
    console.log(`Switching to locale: ${locale}`);
    i18n.changeLanguage(locale);
  };

  const navigationSections = [
    {
      items: [
        {
          url: "/places/locations",
          label: t("places.navigation.locations"),
          icon: LocationsMinor,
          secondaryAction: {
            url: "/places/locations/new",
            icon: CirclePlusOutlineMinor,
            tooltip: {
              content: t("places.navigation.addLocation"),
            },
          },
        },
      ],
    },
    {
      separator: true,
      fill: true,
      items: [
        {
          url: "/places/cities",
          label: t("places.navigation.cities"),
        },
        {
          url: "/places/regions",
          label: t("places.navigation.regions"),
        },
        {
          url: "/places/countries",
          label: t("places.navigation.countries"),
        },
      ],
    },
    {
      separator: true,
      items: [
        {
          url: "/places/map",
          label: t("places.navigation.showOnMap"),
          icon: GlobeMinor,
        },
      ],
    },
  ];

  return (
      <TabContainer sections={navigationSections}>
        
        <Routes>
          <Route index element={<Navigate to="locations" />} />

          <Route path="locations"  element={<LocationsIndex />} />
          <Route path="locations/new" element={<LocationNew />} />
          <Route path="locations/:id" element={<LocationEdit />} />

          <Route path="upload/new" element={<LocationsImportNew />} />
          <Route path="upload" element={<LocationsImportShow />} />

          <Route path="cities" element={<CitiesIndex />} />
          <Route path="/cities/:id" element={<CitiesEdit />} />

          <Route path="regions" element={<RegionsIndex />} />
          <Route path="/regions/:id" element={<RegionsEdit />} />

          <Route path="countries" element={<CountriesIndex />} />
          <Route path="/countries/:id" element={<CountriesEdit />} />

          <Route path="map" element={<LocationMap />} />

          {/* Fallback Route */}
          <Route
              path="*"
              element={
                <div style={{padding: "1rem" }}>
                <div style={{ borderRadius: ".5rem", backgroundColor: "white", padding: "20px", textAlign: "center" }}>
                  <h1>{t("places.welcome.title")}</h1>
                  <p>{t("places.welcome.subtitle")}</p>
                </div>
                {/* <div style={{ 
                  marginTop: "1.5rem", 
                  borderRadius: "8px", 
                  background: "linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%)", 
                  padding: "24px", 
                  border: "1px solid #0ea5e9"
                }}>
                  <h2 style={{ 
                    margin: "0 0 12px 0", 
                    color: "#0c4a6e", 
                    fontSize: "1.25rem",
                    fontWeight: "600"
                  }}>
                    🎉 Language Support is now available
                  </h2>
                  <p style={{ 
                    margin: "0 0 8px 0", 
                    color: "#0369a1", 
                    lineHeight: "1.5",
                    fontSize: "0.95rem"
                  }}>
                    You can now change your default language to something other than English. On Superest Plans and above, you can enable multiple languages for your content to display in.
                  </p>
                  <p style={{ 
                    margin: "0 0 16px 0", 
                    color: "#0369a1", 
                    lineHeight: "1.5",
                    fontSize: "0.9rem",
                    fontStyle: "italic"
                  }}>
                    Go to Settings → Languages to adjust your language settings.
                  </p>
                  <div style={{ display: "flex", gap: "12px", flexWrap: "wrap" }}>
                    <a 
                      href="https://docs.sosuper.app/article/57-language-support" 
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{
                        display: "inline-block",
                        padding: "8px 16px",
                        backgroundColor: "transparent",
                        color: "#0ea5e9",
                        textDecoration: "none",
                        borderRadius: "6px",
                        fontSize: "0.875rem",
                        fontWeight: "500",
                        border: "1px solid #0ea5e9",
                        transition: "all 0.2s ease"
                      }}
                      onMouseOver={(e) => {
                        e.target.style.backgroundColor = "#0ea5e9";
                        e.target.style.color = "white";
                      }}
                      onMouseOut={(e) => {
                        e.target.style.backgroundColor = "transparent";
                        e.target.style.color = "#0ea5e9";
                      }}
                    >
                      Learn More
                    </a>
                  </div>
                  <style>{`
                    @keyframes pulse {
                      0% { opacity: 1; }
                      50% { opacity: 0.5; }
                      100% { opacity: 1; }
                    }
                  `}</style>
                </div> */}
                </div>
              }
          />
        </Routes>
      </TabContainer>
  );
}
